<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Terms &amp; Conditions</h1>
      </div>
      <div class="header-actions">
        <a class="action-button" routerLink="/settings">← Back</a>
      </div>
    </header>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Terms &amp; Conditions</h2>
        <p class="panel-description">These terms appear on all estimates.</p>
      </div>
      <div class="panel-content">
        <div class="terms-editor">
          @for (term of terms; track $index) {
            <div class="term-item">
              <textarea
                class="form-input term-textarea"
                [(ngModel)]="terms[$index]"
                rows="2"
                placeholder="Enter term or condition..."
              ></textarea>
              <button class="action-button danger-text" (click)="removeTerm($index)" type="button">
                Remove
              </button>
            </div>
          }
          <button class="action-button" (click)="addTerm()" type="button">
            + Add term
          </button>
        </div>
        <button class="action-button primary" (click)="save()" [disabled]="saving()">
          {{ saving() ? "Saving..." : "Save terms" }}
        </button>
      </div>
    </div>

    @if (message(); as message) {
      <div class="status-message">{{ message }}</div>
    }
  </div>
</section>
